import { render, staticRenderFns } from "./CoursePromotionList.vue?vue&type=template&id=31b936d6&scoped=true"
import script from "./CoursePromotionList.vue?vue&type=script&lang=js"
export * from "./CoursePromotionList.vue?vue&type=script&lang=js"
import style0 from "./CoursePromotionList.vue?vue&type=style&index=0&id=31b936d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b936d6",
  null
  
)

export default component.exports